<template>
    <div class="search-input-form">
        <input
            v-bind="$attrs"
            v-on="listeners"
            type="text"
            class="search-input-form__field search-field"
        >
        <button type="button" class="search-input-form__submit search-button">
            <svg width="24" height="24">
                <use xlink:href="/sprite.svg#icon-search"></use>
            </svg>
            Поиск
        </button>
    </div>
</template>

<script>
export default {
    name: 'search-input-form',

    inheritAttrs: false,

    computed: {
        listeners() {
            return Object.assign(
                this.$listeners,
                {
                    input: ({ target }) => {
                        this.$emit('input', target.value);
                    },
                },
            );
        },
    },
};
</script>
